export enum phaseEnum {
	exploitation = 'Exploitation'
}
